export function getFieldType(key: string, scope: string, dataSchema: any) {
	let targetSchema = dataSchema

	if (scope && scope !== "#/properties") {
		const parts = scope.split("/").filter((p: string) => p && p !== "#")
		for (const part of parts) {
			if (part === "properties" || part === "items") continue
			if (targetSchema.properties && targetSchema.properties[part]) {
				targetSchema = targetSchema.properties[part]
			}
		}

		if (targetSchema.type === "array" && targetSchema.items) {
			targetSchema = targetSchema.items
		}
	}

	if (targetSchema.properties && targetSchema.properties[key]) {
		const fieldSchema = targetSchema.properties[key]
		const type = Array.isArray(fieldSchema.type) ? fieldSchema.type[0] : fieldSchema.type

		if (fieldSchema.enum) {
			return { type: "select", options: fieldSchema.enum }
		}

		switch (type) {
			case "string":
				return { type: "text" }
			case "number":
				return { type: "number" }
			case "boolean":
				return { type: "checkbox" }
			case "array":
				return { type: "textarea" }
			default:
				return { type: "text" }
		}
	}

	return { type: "text" }
}

export function getSchemaKeys(scope: string, dataSchema: any, parentScope?: string): string[] {
	let targetSchema = dataSchema

	if (parentScope) {
		const parentParts = parentScope.split("/").filter((p) => p && p !== "#" && p !== "properties")
		for (const part of parentParts) {
			if (targetSchema.properties && targetSchema.properties[part]) {
				targetSchema = targetSchema.properties[part]
			}
		}
		if (targetSchema.type === "array" && targetSchema.items) {
			targetSchema = targetSchema.items
		}
	}

	if (scope && scope !== "#/properties") {
		const parts = scope.split("/").filter((p: string) => p && p !== "#")
		for (const part of parts) {
			if (part === "properties" || part === "items") continue
			if (targetSchema.properties && targetSchema.properties[part]) {
				targetSchema = targetSchema.properties[part]
			}
		}
	}

	if (targetSchema.type === "array" && targetSchema.items) {
		targetSchema = targetSchema.items
	}

	if (targetSchema.properties) {
		return Object.keys(targetSchema.properties)
	}

	return []
}

export function getResolvedData(scope: string, data: any, parentData?: any) {
	const baseData = parentData || data
	if (!baseData || !scope) return baseData

	let current = baseData
	const parts = scope.split("/").filter((p: string) => p && p !== "#" && p !== "properties")

	for (const part of parts) {
		if (current && current[part] !== undefined) {
			current = current[part]
		} else {
			return null
		}
	}

	return current
}

